/**
 * Centralized storage utility.
 * All localStorage / sessionStorage keys are defined here to avoid magic strings.
 */

export const STORAGE_KEYS = {
  IS_LOGIN: 'isLogin',
  AUTH_TOKEN: 'authToken',
  REFRESH_TOKEN: 'refreshToken',
  SPECIAL_MODE_CODE: 'specialModeCode',
  LOCALE: 'locale',
  IS_SOCIAL_CATEGORIES_SELECTED: 'isSocialCategoriesSelected',
  LOCATION_PERMISSION_STATE: 'locationPermissionState',
  CONSENT: 'coridor_consent',
  TRUSTED_DEVICE_TOKEN: 'trustedDeviceToken'
}

export const SESSION_KEYS = {
  SOCIAL_LOGIN_ID: 'socialLoginId',
  SOCIAL_LOGIN_NAME: 'socialLoginName',
  EVENT_NOTIFICATION_SHOWN: 'eventNotificationShown'
}

const safeGet = (storage, key) => {
  try {
    return storage.getItem(key)
  } catch {
    return null
  }
}

const safeSet = (storage, key, value) => {
  try {
    storage.setItem(key, value)
  } catch {
    // ignore (e.g. private browsing quota)
  }
}

const safeRemove = (storage, key) => {
  try {
    storage.removeItem(key)
  } catch {
    // ignore
  }
}

export const local = {
  get: (key) => safeGet(localStorage, key),
  set: (key, value) => safeSet(localStorage, key, value),
  remove: (key) => safeRemove(localStorage, key)
}

export const session = {
  get: (key) => safeGet(sessionStorage, key),
  set: (key, value) => safeSet(sessionStorage, key, value),
  remove: (key) => safeRemove(sessionStorage, key)
}

export const getStoredSpecialModeCode = () => {
  return local.get(STORAGE_KEYS.SPECIAL_MODE_CODE) || ''
}

export const setStoredSpecialModeCode = (value) => {
  if (!value) {
    return clearStoredSpecialModeCode()
  }

  local.set(STORAGE_KEYS.SPECIAL_MODE_CODE, value)
}

export const clearStoredSpecialModeCode = () => {
  local.remove(STORAGE_KEYS.SPECIAL_MODE_CODE)
}
